import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'getKeysPipe',
})
export class GetKeysPipe implements PipeTransform {

  /**
   * Transforms to display json object using *ngFor
   * @param value the json Obje
   * @returns a vector with the keys and values
   */

  transform(value: any, ...args: any[]): any {
    let keys = [];
    for (let key in value) {
      keys.push({key: key, value: value[key]});
    }
    console.log("PIPE KEYS", keys);
    return keys;
  }

}



// WEBPACK FOOTER //
// ./src/pipes/utils/get-keys-pipe.ts